import React, { Component } from 'react'
import { translation } from '../../../../utils/helpers'
import moment from 'moment'

import ScrollingCalendar from '../../../elements/scrollingCalendar'

import './calendarheader.scss'
import Icon from '../../../elements/icon'
import { GeneralIcons } from '../../../elements/icons'

class CalendarHeader extends Component {
  render () {
    switch (this.props.viewMode) {
      case 'month': return this.renderMonthView()
      case 'week' : return this.renderWeekView()
    }
  }

  renderMonthView () {
    return (
      <div className='calendar-header'>
        <div className='calendar-header__buttons'>
          {this.props.renderButtons()}
        </div>
        <div className='calendar-header__content month'>
          <ScrollingCalendar onItemClick={this.props.onItemClick} onRangeUpdated={this.props.onRangeUpdated} showFromDate={moment(this.props.showFromDate)} />
        </div>
      </div>
    )
  }

  renderDay (item, key) {
    // const text = translation(item.LongTextDictionaryKey)
    const active = item.isSame(moment(), 'day')
    const text = item.format('dddd')
    // const date = item.Text || moment(item.Date).format('DD.MM')
    const date = item.format('DD.MM')
    let classNames = 'calendar-header__item'
    if (active) {
      classNames += ' active'
    }

    return (
      <div className={classNames} key={key}>
        <div className='calendar-header__txt'>{text}</div>
        <div className='calendar-header__date'>{date}</div>
      </div>
    )
  }

  /**
   * Renders header for week + navigation (at some point refactor to new component, same as month view)
   * @returns
   */
  renderWeekView () {
    // const { headerItems } = this.props

    // Determine days to display
    let fromDate = this.props.showFromDate
    let days = []
    for (let d = 0; d < 7; d++) {
      let day = moment(fromDate).add(d, 'days')
      days.push(day)
    }

    const contentStyle = {
      gridTemplateColumns: `repeat(${days.length}, minmax(48px, 1fr))`
    }

    let now = moment()
    let showGotoNow = now.isBefore(days[0], 'day') || now.isAfter(days[days.length - 1], 'day')

    const navPrev = () => {
      let from = moment(fromDate).startOf('week').subtract(7, 'days')
      let to = moment(from).add(7, 'days')
      this.props.onRangeUpdated(from, to)
    }

    const navNext = () => {
      let from = moment(fromDate).startOf('week').add(7, 'days')
      let to = moment(from).add(7, 'days')
      this.props.onRangeUpdated(from, to)
    }

    return (
      <div className='calendar-header'>
        <div className='calendar-header__buttons'>
          {this.props.renderButtons()}
        </div>
        <div className='calendar-header__content week' >
          <div className='controls'>
            {showGotoNow && <div className='go-to-now' onClick={() => { this.props.onRangeUpdated(moment(now).startOf('week'), moment(now).endOf('week')) }}>{translation(18281)}</div> || <div>&nbsp;</div>}
            <div className='nav'>
              <div className='prev'><Icon icon={GeneralIcons.Arrow_Left_Blue} size='t' onClick={navPrev} /></div>
              <div className='current'>{translation(250) + ' ' + fromDate.format('W')}</div>
              <div className='next'><Icon icon={GeneralIcons.Arrow_Right_Blue} size='t' onClick={navNext} /></div>
            </div>
          </div>
          <div className='days' style={contentStyle}>
            {days.map(this.renderDay)}
          </div>
        </div>
      </div>
    )
  }
}

CalendarHeader.defaultProps = {
  viewMode: 'month',   // 'month' or 'week'
  showFromDate: null, // moment
  onItemClick: null,
  onRangeUpdated: null,
  renderButtons: () => { return <div>&nbsp;</div> }

  // // Test data
  // headerItems: [
  //   { Text: '14.12', TextDictionaryKey: '169', ShortTextDictionaryKey: '15133', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
  //   { Text: '15.12', TextDictionaryKey: '170', ShortTextDictionaryKey: '15134', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
  //   { Text: '16.12', TextDictionaryKey: '171', ShortTextDictionaryKey: '15135', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
  //   { Text: '17.12', TextDictionaryKey: '172', ShortTextDictionaryKey: '15136', Date: '2020-12-14T00:00:00', Active: true, IsClosed: false },
  //   { Text: '18.12', TextDictionaryKey: '173', ShortTextDictionaryKey: '15137', Date: '2020-12-14T00:00:00', Active: false, IsClosed: false },
  //   { Text: '19.12', TextDictionaryKey: '174', ShortTextDictionaryKey: '15138', Date: '2020-12-14T00:00:00', Active: false, IsClosed: true },
  //   { Text: '20.12', TextDictionaryKey: '175', ShortTextDictionaryKey: '15139', Date: '2020-12-14T00:00:00', Active: false, IsClosed: true }
  // ]
}

export default CalendarHeader



// WEBPACK FOOTER //
// ./src/app/shared/components/Calendar/calendarHeader/index.js